import React from 'react';
import {
  DialogActions as MuiDialogActions,
  DialogActionsProps as MuiDialogActionsProps,
  useMediaQuery,
  useTheme,
} from '@mui/material';

type DialogActionsProps = MuiDialogActionsProps & {
  children?: any;
};

export const DialogActions = ({ children = null, sx, ...rest }: DialogActionsProps) => {
  const theme = useTheme();
  const down_sm = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <MuiDialogActions
      sx={{
        justifyContent: 'flex-start',
        paddingX: down_sm ? 3 : 8,
        paddingBottom: 6,
        ...sx,
      }}
      {...rest}
    >
      {children}
    </MuiDialogActions>
  );
};
